var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-spinner",class:{
    'tw-inline-block': true,
    [_vm.size]: true,
  }},[_c('div',{staticClass:"animation",class:[
      {
        'tw-border-gray-400': !_vm.animationClass,
        [_vm.animationClass]: _vm.animationClass,
      },
    ]})])
}
var staticRenderFns = []

export { render, staticRenderFns }